(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fuelme-cart-styles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async event => {
    if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('#cart-drawer a[data-fm-cart-link]');
    if (!link) return;
    const drawer = link.closest('theme-drawer');
    if (typeof drawer?.close !== 'function') return;
    event.preventDefault();
    const destination = new URL(link.href);
    await drawer.close();
    if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search && destination.hash) {
      const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
      if (target) {
        if (location.href !== destination.href) history.pushState(history.state, '', destination.href);
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        return;
      }
    }
    location.assign(destination.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fuelme-launch-mobile-shop"] && !Shopify.designMode) return;
  try {
    (() => {const bar=document.querySelector('[data-launch-shop]');if(!bar)return;const main=document.getElementById('MainContent');const first=main?.querySelector('h1')||main?.firstElementChild;const footer=document.querySelector('.fm-footer');if(!first||!('IntersectionObserver' in window))return;let past=false,atFooter=false;const update=()=>{bar.hidden=!past||atFooter;};const topObserver=new IntersectionObserver(entries=>{past=!entries[0].isIntersecting&&entries[0].boundingClientRect.bottom<0;update();},{rootMargin:`${Math.round(window.innerHeight*.6)}px 0px 0px`});topObserver.observe(first);if(footer){const footObserver=new IntersectionObserver(entries=>{atFooter=entries[0].isIntersecting;update();});footObserver.observe(footer);}})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fuelme-launch-route-bridges"] && !Shopify.designMode) return;
  try {
    (() => {
 const root = window.Shopify?.routes?.root || '/';
 const route = location.pathname.replace(root, '').replace(/\/$/, '');
 const hash = location.hash;
 if (route === 'pages/landing-page') {
  const destinations = {'#flp-flavors':'collections/all','#flp-nutrition':'pages/inside-fuelme#fm-nutrition','#flp-how':'pages/how-it-works#how-it-works','#flp-faq':'pages/faq'};
  location.replace(root + (destinations[hash] || 'pages/inside-fuelme'));
  return;
 }
 if (!route && hash.startsWith('#faq-')) location.replace(root + 'pages/faq' + hash);
 if (!route && hash === '#nutrition') location.replace(root + 'pages/inside-fuelme#fm-nutrition');
 if (route === 'pages/inside-fuelme' && ['#fm-everyday','#fm-value','#fd-portions','#fd-moments','#fd-ritual','#fd-value'].includes(hash)) {
  location.replace(root + 'pages/how-it-works' + (hash.includes('value') ? '#launch-value' : hash.includes('portion') ? '#launch-portions' : hash.includes('ritual') ? '#how-it-works' : '#fm-everyday'));
 }
 if (route === 'pages/inside-fuelme' && hash.startsWith('#fd-')) {
  const map = { 'formula':'formula','ingredients':'ingredients','sourcing':'quality','clean-recipe':'quality','extras':'ingredients','functions':'benefits','nutrition':'nutrition','comparison':'comparison','flavors':'flavors','guide':'formula','questions':'nutrition','advantage':'formula','hero':'title' };
  const target = map[hash.slice(4)];
  if (target) location.replace('#fm-' + target);
 }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fuelme-product-studio"] && !Shopify.designMode) return;
  try {
    class FuelmeProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const {signal} = this.abort;
      const hidden = this.querySelector('[data-fm-variant]');
      hidden.name = 'id';
      const radios = this.querySelectorAll('[name="fuelme-package"]');
      const button = this.querySelector('.fm-pdp-add');
      const select = radio => {
        hidden.value = radio.value;
        button.disabled = radio.dataset.available !== 'true';
        const text = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (text) text.textContent = button.disabled ? this.dataset.soldText : this.dataset.addText;
        this.querySelectorAll('[data-fm-price]').forEach(el => el.textContent = radio.dataset.price);
        this.querySelector('[data-fm-selected-title]').textContent = radio.dataset.title;
        const url = new URL(location.href);
        url.searchParams.set('variant',radio.value);
        history.replaceState(history.state,'',url);
      };
      radios.forEach(radio => radio.addEventListener('change',() => select(radio),{signal}));
      window.addEventListener('popstate',() => {
        const id = new URL(location.href).searchParams.get('variant');
        const radio = Array.from(radios).find(el => el.value === id) || radios[0];
        if (radio) { radio.checked = true; select(radio); }
      },{signal});
      const track = this.querySelector('.fm-pdp-slides');
      const slides = Array.from(track.children);
      const links = this.querySelectorAll('.fm-pdp-thumbnails a');
      links.forEach(link => link.addEventListener('click',event => {
        event.preventDefault();
        const slide = slides.find(el => '#'+el.id === link.getAttribute('href'));
        if (slide) track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      },{signal}));
      this.galleryObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) links.forEach(link => {
          if (link.getAttribute('href') === '#'+entry.target.id) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
        });
      }),{root:track,threshold:.6});
      slides.forEach(slide => this.galleryObserver.observe(slide));
      const sticky = this.querySelector('.fm-pdp-sticky');
      this.buyObserver = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; },{threshold:0});
      this.buyObserver.observe(this.querySelector('.fm-pdp-purchase'));
      this.querySelectorAll('.fm-pdp-label-data div').forEach(div => {
        if (div.style.overflowX === 'auto' && !div.dataset.fmBasis) {
          div.tabIndex = 0;
          div.setAttribute('role','region');
          div.setAttribute('aria-label',div.querySelector('caption')?.textContent || this.dataset.nutritionLabel);
          div.dataset.fmBasis = 'sachet';
          const group = document.createElement('div');
          group.className = 'fm-pdp-table-switch';
          ['sachet','prepared'].forEach(basis => {
            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.textContent = basis === 'sachet' ? this.dataset.basisSachet : this.dataset.basisPrepared;
            toggle.setAttribute('aria-pressed',String(basis === 'sachet'));
            toggle.addEventListener('click',() => {
              div.dataset.fmBasis = basis;
              group.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed',String(item === toggle)));
            },{signal});
            group.append(toggle);
          });
          div.before(group);
        }
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.galleryObserver?.disconnect(); this.buyObserver?.disconnect(); this.ready = false; }
  }
  if (!customElements.get('fuelme-product')) customElements.define('fuelme-product',FuelmeProduct);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ultimate-system"] && !Shopify.designMode) return;
  try {
    function ultimateInit(root){
 root.querySelectorAll('[data-u-flavors]').forEach(section=>{
  if(section.dataset.ready)return;
  const nav=section.querySelector('.u-flavor-nav');
  const tabs=[...section.querySelectorAll('[data-u-tab]')];
  const panels=[...section.querySelectorAll('[data-u-panel]')];
  if(!tabs.length||tabs.length!==panels.length)return;
  section.dataset.ready='true';nav.setAttribute('role','tablist');
  tabs.forEach((tab,i)=>{tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panels[i].id);panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',tab.id);panels[i].setAttribute('tabindex','0');});
  const activate=(index,focus=false)=>{panels[index].querySelectorAll('img').forEach(image=>{image.loading='eager';});tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(index===i));tab.tabIndex=index===i?0:-1;panels[i].hidden=index!==i;});if(focus)tabs[index].focus();};
  tabs.forEach((tab,i)=>{tab.addEventListener('click',event=>{event.preventDefault();if(document.startViewTransition&&!matchMedia('(prefers-reduced-motion: reduce)').matches){document.startViewTransition(()=>activate(i));}else{activate(i);}});tab.addEventListener('keydown',event=>{let n=i;if(event.key==='ArrowRight')n=(i+1)%tabs.length;else if(event.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(event.key==='Home')n=0;else if(event.key==='End')n=tabs.length-1;else return;event.preventDefault();activate(n,true);});});
  activate(0);
  section.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-u-panel]');const i=panels.indexOf(panel);if(i>=0)activate(i);});
 });
}
ultimateInit(document);
document.addEventListener('shopify:section:load',event=>ultimateInit(event.target));
  } catch(e) { console.error(e); }
})();

})();
